module.exports = __webpack_public_path__ + "img/09.5eaf113b.png";